namespace GeniuzPOS.CustomReport {
    export namespace ReportCustomerSurveyTranDtService {
        export const baseUrl = 'CustomReport/ReportCustomerSurveyTranDt';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportCustomerSurveyTranDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportCustomerSurveyTranDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "CustomReport/ReportCustomerSurveyTranDt/Retrieve",
            List = "CustomReport/ReportCustomerSurveyTranDt/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportCustomerSurveyTranDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
